module.exports = {"TXTWCL_odds_boost":{"id":"TXTWCL_odds_boost","defaultMessage":"z podbiciem kursu"}}